import React, { useCallback, useContext } from "react";
import { FaRedoAlt, FaUndoAlt } from "react-icons/fa";
import { EditorContext, useEditorState } from "@tiptap/react";

const historyIcons = {
    undo: FaUndoAlt,
    redo: FaRedoAlt
};

const historyActionLabels = {
    undo: "Desfazer (Ctrl+Z)",
    redo: "Refazer (Ctrl+Shift+Z)"
};

const executeHistoryAction = (editor, action) => {
    if (!editor || editor.isDestroyed) return false;

    if (action === "undo") {
        editor
            .chain()
            .focus()
            .undo()
            .run();

        return;
    }

    editor
        .chain()
        .focus()
        .redo()
        .run();
};

const RichTextUndoRedoButton = ({ action, disabled = false }) => {
    const { editor } = useContext(EditorContext);

    if (!editor || !editor.isEditable) return null;

    return (
        <RichTextUndoRedoButtonContent
            editor={editor}
            action={action}
            disabled={disabled}
        />
    );
};

const RichTextUndoRedoButtonContent = ({ editor, action, disabled }) => {
    const canExecute = useEditorState({
        editor,
        selector: ({ editor }) => {
            if (!editor || editor.isDestroyed) return false;

            return action === "undo"
                ? editor.can().undo()
                : editor.can().redo();
        }
    });

    const isDisabled = disabled || !canExecute;

    const handleClick = useCallback(
        (e) => {
            e.preventDefault();

            if (isDisabled) return;

            executeHistoryAction(editor, action);
        },
        [editor, action, isDisabled]
    );

    const Icon = historyIcons[action];

    if (!Icon) return null;

    return (
        <button
            type="button"
            className="rich-text-button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={handleClick}
            disabled={isDisabled}
            title={historyActionLabels[action]}
        >
            <Icon className="rich-text-button-icon" />
        </button>
    );
};

export default RichTextUndoRedoButton;